<f-chart
  [view]="view"
  [xScale]="xScale"
  [yScale]="yScale"
  [animation]="animation"
  [integerYAxis]="integerYAxis"
  [fitContainer]="fitContainer"
  [truncateXAxisTicks]="truncateXAxisTicks"
  [truncateYAxisTicks]="truncateYAxisTicks"
  [rotateXAxisTicks]="rotateXAxisTicks"
  [maxXAxisTickLength]="maxXAxisTickLength"
  [maxYAxisTickLength]="maxYAxisTickLength"
  [maxYAxisTicksCount]="maxTicksCount"
  [xAxisTickFormatting]="xAxisTickFormatting"
  [yAxisTickFormatting]="yAxisTickFormatting"
  [showXAxisGridlines]="showXAxisGridlines"
  [showYAxisGridlines]="showYAxisGridlines"
  [showXAxisTicksLabels]="showXAxisTicksLabels"
  [showYAxisTicksLabels]="showYAxisTicksLabels"
  [showLineAxisTicksLabels]="showLineAxisTicksLabels"
  [xAxisTickLabelClasses]="xAxisTickLabelClasses"
  [xAxisTickLabelOffset]="xAxisTickLabelOffset"
  [showBarsOptionalData]="showBarsOptionalData"
  [showXAxisDomain]="showXAxisDomain"
  [showYAxisDomain]="showYAxisDomain"
  [popoverTemplate]="popoverTemplate"
  [popoverPlacement]="popoverPlacement"
  [legendOptions]="legendOptions"
  [showLegend]="showLegend"
  [leftAxisLabelText]="leftAxisLabelText"
  [labelsOffset]="labelsOffset"
  [showLabels]="showLabels"
  [showBorders]="showBorders"
  [condensedOnDesktop]="condensedOnDesktop"
  [condensedAxisOnMobile]="condensedAxisOnMobile"
  [chartPatternsTemplate]="chartPatternsTemplate"
  (dimensionsChanged)="onDimensionsChanged($event)"
>
  <svg:g
    *ngIf="dimensions"
    f-bar-series
    [series]="data"
    [xScale]="xScale"
    [yScale]="yScale"
    [dimensions]="dimensions"
    [barClasses]="barClasses"
    [animation]="animation"
    [condensedOnDesktop]="condensedOnDesktop"
    [interactions]="interactions"
    [parentChartComponent]="chartComponent"
    [animationDuration]="animationDuration"
    [popoverTemplate]="popoverTemplate"
    [popoverPlacement]="popoverPlacement"
    [popoverOpenDelay]="popoverOpenDelay"
    [popoverCssClass]="popoverCssClass"
    [showOptionalData]="showBarsOptionalData"
    [barBubbleShowZero]="infoBubbleShowZero"
    [barBubbleTextClasses]="infoBubbleTextClasses"
    [barBubbleClasses]="infoBubbleClasses"
    [activeBarIndex]="activeBarIndex"
    [showDataLabels]="showDataLabels"
    (seriesClick)="onBarClick($event)"
    (seriesHover)="onBarHover($event)"
  />
</f-chart>
